import { PageWithDescriptionsProps } from 'strapi/page/types';
import { pageTypes } from 'strapi/pageTypes';

import { KeyPointsProps } from '../shared/KeyPointsColumn/types';

export interface KeyPointsColumnAutoFilledStrapiComponent {
  title: string;
}

export interface KeyPointsColumnAutoFilledProps {
  title: string;
  keyPoints: KeyPointsProps[];
}

export const MICRO_APP_PAGE_TYPES = [
  pageTypes.VECTORIZER_COLLECTION_TYPE,
  pageTypes.AI_IMAGE_GENERATOR_COLLECTION_TYPE,
  pageTypes.AI_VECTOR_GENERATOR_COLLECTION_TYPE,
  pageTypes.BACKGROUND_REMOVER_MICRO_APP,
] as const;

export type MicroAppPageType = (typeof MICRO_APP_PAGE_TYPES)[number];

export const isPageWithDescriptions = (
  page: unknown
): page is PageWithDescriptionsProps => {
  return (
    !!page &&
    typeof page === 'object' &&
    'descriptiveName' in page &&
    'pageDescription' in page &&
    'path' in page &&
    'cover' in page
  );
};

export const isMicroAppPageType = (
  pageType: string
): pageType is MicroAppPageType =>
  MICRO_APP_PAGE_TYPES.includes(pageType as MicroAppPageType);
